import type { GenerateQrRequest } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { qrApi } from '../api'

interface QrVars {
  params: GenerateQrRequest
  logo?: File | null
}

export function useGenerateQr(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ params, logo }: QrVars) => qrApi.generate(businessId, params, logo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
